import styled from 'styled-components'

export const StyledContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1;
`

export const StyledHelperText = styled.div`
  maring-top: 4px;
  font-size: 12px;
  color: #0000008a;
  display: flex;
  justify-content: flex-end;
  padding-left: 10px;
  font-size: 0.75rem;
  margin-top: 3px;
`

export const StyledLabel = styled.label`
  position: absolute;
  top: ${({ isFocusedOrFilled }) => (isFocusedOrFilled ? '-10px' : '8px')};
  left: 8px;
  font-size: ${({ isFocusedOrFilled }) => (isFocusedOrFilled ? '12px' : '14px')};
  color: #495057;
  background: white;
  padding: 0 4px;
  transition: all 0.2s ease-out;
  pointer-events: none;
`

export const StyledTextarea = styled.textarea`
  resize: none;
  font-size: 14px;
  border: 1px solid #7ca5ca;
  border-radius: 4px;
  outline-style: none;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  color: rgba(0, 0, 0, 0.87);
  flex: 1;
  min-height: 90px;
  max-height: 90px;
  overflow-y: auto;
  padding: 16px 8px 8px 8px;
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    background: none;
  }
  ::-webkit-scrollbar-thumb {
    background: #c8cbcd;
    border-radius: 5px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`
